import { SQLService } from '../../services/sql.service';
import { Flip } from '../../app.animations';
import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute,NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavParams } from '@ionic/angular';
@Component({
  selector: 'app-select-salary',
  templateUrl: './select-salary.page.html',
  styleUrls: ['./select-salary.page.styl'],
  animations: [ Flip ]
})
export class SelectSalaryPage implements OnInit {
  constructor(
    private router: Router,
    public sql: SQLService,
    private route: ActivatedRoute,
    private navCtrl: ModalController,
    private location: Location,
    private params: NavParams
  ) {
    var s = params.get('selected');
    if(s)this.selected = s.split(',');
    this.multiple = params.get('select_multiple');
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_salaries();
    });
  }
  count = -1;
  salaries = [];
  selected = [];
  multiple: boolean;
  output = new EventEmitter();
  @Input('set_table') table:string;
  @Input('set_model') model:string;
  @Input('set_model_id') id:string;
  ngOnInit() {
    this.get_salaries();
    this.id = this.route.snapshot.paramMap.get("id");
    this.table = this.route.snapshot.paramMap.get("table");
    this.model = this.route.snapshot.paramMap.get("model");
  }
  get_salaries(event?) {
    this.sql.fetch('Salaries',(e)=>{
      this.salaries=e;
      this.count=e.length;
      setTimeout(()=>{if (event) event.target.complete();},1234);
    });
  }
  select_none() {this.navCtrl.dismiss(-1);}
  select(e) { 
    if (this.id) {
      let a = 'salary';
      this.sql.query('UPDATE '+this.table+' '+( this.id?'WHERE '+this.model+' = '+this.id:'' )+' SET '+a+'_id = '+e[a+'_id']);
      this.location.back();
    }
    this.navCtrl.dismiss(e);
  }
  add() {
    this.router.navigate(['folder','Salary','New']);
    this.navCtrl.dismiss();
  }
  end() {
    this.navCtrl.dismiss();
  }
}